import createIcon from '../../createIcon';

/**
 * @component @name FlipToBack
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOSA3SDdWOUg5VjdaTTkgMTFIN1YxM0g5VjExWk05IDNDNy44OSAzIDcgMy45IDcgNUg5VjNaTTEzIDE1SDExVjE3SDEzVjE1Wk0xOSAzVjVIMjFDMjEgMy45IDIwLjEgMyAxOSAzWk0xMyAzSDExVjVIMTNWM1pNOSAxN1YxNUg3QzcgMTYuMSA3Ljg5IDE3IDkgMTdaTTE5IDEzSDIxVjExSDE5VjEzWk0xOSA5SDIxVjdIMTlWOVpNMTkgMTdDMjAuMSAxNyAyMSAxNi4xIDIxIDE1SDE5VjE3Wk01IDdIM1YxOUMzIDIwLjEgMy44OSAyMSA1IDIxSDE3VjE5SDVWN1pNMTUgNUgxN1YzSDE1VjVaTTE1IDE3SDE3VjE1SDE1VjE3WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FlipToBack = createIcon('FlipToBack', [
  [
    'path',
    {
      d: 'M9 7H7V9H9V7ZM9 11H7V13H9V11ZM9 3C7.89 3 7 3.9 7 5H9V3ZM13 15H11V17H13V15ZM19 3V5H21C21 3.9 20.1 3 19 3ZM13 3H11V5H13V3ZM9 17V15H7C7 16.1 7.89 17 9 17ZM19 13H21V11H19V13ZM19 9H21V7H19V9ZM19 17C20.1 17 21 16.1 21 15H19V17ZM5 7H3V19C3 20.1 3.89 21 5 21H17V19H5V7ZM15 5H17V3H15V5ZM15 17H17V15H15V17Z',
      key: '1i0obw',
    },
  ],
]);

export default FlipToBack;
